/**
 * Generated file, do not edit directly!
 */

/** Colors are essential for creating a cohesive and visually appealing design system. They help establish visual hierarchy, improve usability and reinforce our brand's identity. */

const Theme = {
  Foreground: {
    /** Css custom property: --dt-colors-theme-foreground-10. Default value: #2d2e4e. */
    '10': 'var(--dt-colors-theme-foreground-10, #2d2e4e)',
    /** Css custom property: --dt-colors-theme-foreground-20. Default value: #fff. */
    '20': 'var(--dt-colors-theme-foreground-20, #fff)',
  },
  Background: {
    Shell: {
      /** Css custom property: --dt-colors-theme-background-shell-default. Default value: #f2f2f5. */
      Default: 'var(--dt-colors-theme-background-shell-default, #f2f2f5)',
    },
    Surface: {
      /** Css custom property: --dt-colors-theme-background-surface-backdrop-embedded. Default value: #f9f9facc. */
      BackdropEmbedded:
        'var(--dt-colors-theme-background-surface-backdrop-embedded, #f9f9facc)',
    },
    /** Css custom property: --dt-colors-theme-background-10. Default value: #f9f9fa. */
    '10': 'var(--dt-colors-theme-background-10, #f9f9fa)',
    /** Css custom property: --dt-colors-theme-background-20. Default value: #fff. */
    '20': 'var(--dt-colors-theme-background-20, #fff)',
  },
  Neutral: {
    /** Css custom property: --dt-colors-theme-neutral-10. Default value: #f2f2f5. */
    '10': 'var(--dt-colors-theme-neutral-10, #f2f2f5)',
    /** Css custom property: --dt-colors-theme-neutral-20. Default value: #ebecf0. */
    '20': 'var(--dt-colors-theme-neutral-20, #ebecf0)',
    /** Css custom property: --dt-colors-theme-neutral-30. Default value: #e4e5eb. */
    '30': 'var(--dt-colors-theme-neutral-30, #e4e5eb)',
    /** Css custom property: --dt-colors-theme-neutral-40. Default value: #dadbe4. */
    '40': 'var(--dt-colors-theme-neutral-40, #dadbe4)',
    /** Css custom property: --dt-colors-theme-neutral-50. Default value: #d0d1dc. */
    '50': 'var(--dt-colors-theme-neutral-50, #d0d1dc)',
    /** Css custom property: --dt-colors-theme-neutral-60. Default value: #c6c7d5. */
    '60': 'var(--dt-colors-theme-neutral-60, #c6c7d5)',
    /** Css custom property: --dt-colors-theme-neutral-70. Default value: #5b5c81. */
    '70': 'var(--dt-colors-theme-neutral-70, #5b5c81)',
    /** Css custom property: --dt-colors-theme-neutral-80. Default value: #4d4e72. */
    '80': 'var(--dt-colors-theme-neutral-80, #4d4e72)',
    /** Css custom property: --dt-colors-theme-neutral-90. Default value: #404164. */
    '90': 'var(--dt-colors-theme-neutral-90, #404164)',
  },
  Primary: {
    /** Css custom property: --dt-colors-theme-primary-10. Default value: #f1f2f9. */
    '10': 'var(--dt-colors-theme-primary-10, #f1f2f9)',
    /** Css custom property: --dt-colors-theme-primary-20. Default value: #e9ecf8. */
    '20': 'var(--dt-colors-theme-primary-20, #e9ecf8)',
    /** Css custom property: --dt-colors-theme-primary-30. Default value: #e1e5f7. */
    '30': 'var(--dt-colors-theme-primary-30, #e1e5f7)',
    /** Css custom property: --dt-colors-theme-primary-40. Default value: #d5dbf6. */
    '40': 'var(--dt-colors-theme-primary-40, #d5dbf6)',
    /** Css custom property: --dt-colors-theme-primary-50. Default value: #c9d1f4. */
    '50': 'var(--dt-colors-theme-primary-50, #c9d1f4)',
    /** Css custom property: --dt-colors-theme-primary-60. Default value: #bdc7f2. */
    '60': 'var(--dt-colors-theme-primary-60, #bdc7f2)',
    /** Css custom property: --dt-colors-theme-primary-70. Default value: #474fcf. */
    '70': 'var(--dt-colors-theme-primary-70, #474fcf)',
    /** Css custom property: --dt-colors-theme-primary-80. Default value: #3b3fbe. */
    '80': 'var(--dt-colors-theme-primary-80, #3b3fbe)',
    /** Css custom property: --dt-colors-theme-primary-90. Default value: #312dad. */
    '90': 'var(--dt-colors-theme-primary-90, #312dad)',
  },
  Success: {
    /** Css custom property: --dt-colors-theme-success-10. Default value: #f1f3f3. */
    '10': 'var(--dt-colors-theme-success-10, #f1f3f3)',
    /** Css custom property: --dt-colors-theme-success-20. Default value: #e8eded. */
    '20': 'var(--dt-colors-theme-success-20, #e8eded)',
    /** Css custom property: --dt-colors-theme-success-30. Default value: #e0e7e6. */
    '30': 'var(--dt-colors-theme-success-30, #e0e7e6)',
    /** Css custom property: --dt-colors-theme-success-40. Default value: #d3dedd. */
    '40': 'var(--dt-colors-theme-success-40, #d3dedd)',
    /** Css custom property: --dt-colors-theme-success-50. Default value: #c7d5d3. */
    '50': 'var(--dt-colors-theme-success-50, #c7d5d3)',
    /** Css custom property: --dt-colors-theme-success-60. Default value: #bbccc9. */
    '60': 'var(--dt-colors-theme-success-60, #bbccc9)',
    /** Css custom property: --dt-colors-theme-success-70. Default value: #2f6862. */
    '70': 'var(--dt-colors-theme-success-70, #2f6862)',
    /** Css custom property: --dt-colors-theme-success-80. Default value: #1f5a54. */
    '80': 'var(--dt-colors-theme-success-80, #1f5a54)',
    /** Css custom property: --dt-colors-theme-success-90. Default value: #0d4c47. */
    '90': 'var(--dt-colors-theme-success-90, #0d4c47)',
  },
  Warning: {
    /** Css custom property: --dt-colors-theme-warning-10. Default value: #f9f6f3. */
    '10': 'var(--dt-colors-theme-warning-10, #f9f6f3)',
    /** Css custom property: --dt-colors-theme-warning-20. Default value: #f9f3ec. */
    '20': 'var(--dt-colors-theme-warning-20, #f9f3ec)',
    /** Css custom property: --dt-colors-theme-warning-30. Default value: #f9f0e5. */
    '30': 'var(--dt-colors-theme-warning-30, #f9f0e5)',
    /** Css custom property: --dt-colors-theme-warning-40. Default value: #f9ebdb. */
    '40': 'var(--dt-colors-theme-warning-40, #f9ebdb)',
    /** Css custom property: --dt-colors-theme-warning-50. Default value: #f9e6d0. */
    '50': 'var(--dt-colors-theme-warning-50, #f9e6d0)',
    /** Css custom property: --dt-colors-theme-warning-60. Default value: #f9e1c6. */
    '60': 'var(--dt-colors-theme-warning-60, #f9e1c6)',
    /** Css custom property: --dt-colors-theme-warning-70. Default value: #eea53c. */
    '70': 'var(--dt-colors-theme-warning-70, #eea53c)',
    /** Css custom property: --dt-colors-theme-warning-80. Default value: #ffb54f. */
    '80': 'var(--dt-colors-theme-warning-80, #ffb54f)',
    /** Css custom property: --dt-colors-theme-warning-90. Default value: #ffc76d. */
    '90': 'var(--dt-colors-theme-warning-90, #ffc76d)',
  },
  Critical: {
    /** Css custom property: --dt-colors-theme-critical-10. Default value: #f9f1f2. */
    '10': 'var(--dt-colors-theme-critical-10, #f9f1f2)',
    /** Css custom property: --dt-colors-theme-critical-20. Default value: #f8e9e9. */
    '20': 'var(--dt-colors-theme-critical-20, #f8e9e9)',
    /** Css custom property: --dt-colors-theme-critical-30. Default value: #f8e1e1. */
    '30': 'var(--dt-colors-theme-critical-30, #f8e1e1)',
    /** Css custom property: --dt-colors-theme-critical-40. Default value: #f6d6d5. */
    '40': 'var(--dt-colors-theme-critical-40, #f6d6d5)',
    /** Css custom property: --dt-colors-theme-critical-50. Default value: #f5cac9. */
    '50': 'var(--dt-colors-theme-critical-50, #f5cac9)',
    /** Css custom property: --dt-colors-theme-critical-60. Default value: #f3bebd. */
    '60': 'var(--dt-colors-theme-critical-60, #f3bebd)',
    /** Css custom property: --dt-colors-theme-critical-70. Default value: #c62239. */
    '70': 'var(--dt-colors-theme-critical-70, #c62239)',
    /** Css custom property: --dt-colors-theme-critical-80. Default value: #b4002b. */
    '80': 'var(--dt-colors-theme-critical-80, #b4002b)',
    /** Css custom property: --dt-colors-theme-critical-90. Default value: #a2001d. */
    '90': 'var(--dt-colors-theme-critical-90, #a2001d)',
  },
};
const Background = {
  Base: {
    /**
     * Use for the background of your app.
     * Css custom property: --dt-colors-background-base-default. Default value: #f9f9fa.
     */
    Default: 'var(--dt-colors-background-base-default, #f9f9fa)',
  },
  Surface: {
    /**
     * Use as the backdrop for surfaces to reduce the visual noise of background elements.
     * Css custom property: --dt-colors-background-surface-backdrop. Default value: #f9f9facc.
     */
    Backdrop: 'var(--dt-colors-background-surface-backdrop, #f9f9facc)',
    /**
     * Use as the backdrop for embedded overlays to reduce the visual noise of background elements.
     * Css custom property: --dt-colors-background-surface-backdrop-embedded. Default value: #f9f9facc.
     */
    BackdropEmbedded:
      'var(--dt-colors-background-surface-backdrop-embedded, #f9f9facc)',
    /**
     * Use for default surface background.
     * Css custom property: --dt-colors-background-surface-default. Default value: #fff.
     */
    Default: 'var(--dt-colors-background-surface-default, #fff)',
  },
  Container: {
    Neutral: {
      /**
       * Use for subtle containers.
       * Css custom property: --dt-colors-background-container-neutral-subdued. Default value: #f9f9fa.
       */
      Subdued: 'var(--dt-colors-background-container-neutral-subdued, #f9f9fa)',
      /**
       * Use for default containers.
       * Css custom property: --dt-colors-background-container-neutral-default. Default value: #f2f2f5.
       */
      Default: 'var(--dt-colors-background-container-neutral-default, #f2f2f5)',
      /**
       * Use for emphasized neutral containers that draw attention.
       * Css custom property: --dt-colors-background-container-neutral-emphasized. Default value: #ebecf0.
       */
      Emphasized:
        'var(--dt-colors-background-container-neutral-emphasized, #ebecf0)',
      /**
       * Use for accentuated neutral containers with high contrast. Use sparingly.
       * Css custom property: --dt-colors-background-container-neutral-accent. Default value: #5b5c81.
       */
      Accent: 'var(--dt-colors-background-container-neutral-accent, #5b5c81)',
    },
    Primary: {
      /**
       * Use for default primary color containers.
       * Css custom property: --dt-colors-background-container-primary-default. Default value: #f1f2f9.
       */
      Default: 'var(--dt-colors-background-container-primary-default, #f1f2f9)',
      /**
       * Use for emphasized primary color containers that draw attention.
       * Css custom property: --dt-colors-background-container-primary-emphasized. Default value: #e9ecf8.
       */
      Emphasized:
        'var(--dt-colors-background-container-primary-emphasized, #e9ecf8)',
      /**
       * Use for accentuated primary color containers with high contrast. Use sparingly.
       * Css custom property: --dt-colors-background-container-primary-accent. Default value: #474fcf.
       */
      Accent: 'var(--dt-colors-background-container-primary-accent, #474fcf)',
    },
    Success: {
      /**
       * Use for default success color containers.
       * Css custom property: --dt-colors-background-container-success-default. Default value: #f1f3f3.
       */
      Default: 'var(--dt-colors-background-container-success-default, #f1f3f3)',
      /**
       * Use for emphasized success color containers that draw attention.
       * Css custom property: --dt-colors-background-container-success-emphasized. Default value: #e8eded.
       */
      Emphasized:
        'var(--dt-colors-background-container-success-emphasized, #e8eded)',
      /**
       * Use for accentuated success color containers with high contrast. Use sparingly.
       * Css custom property: --dt-colors-background-container-success-accent. Default value: #2f6862.
       */
      Accent: 'var(--dt-colors-background-container-success-accent, #2f6862)',
    },
    Warning: {
      /**
       * Use for default warning color containers.
       * Css custom property: --dt-colors-background-container-warning-default. Default value: #f9f6f3.
       */
      Default: 'var(--dt-colors-background-container-warning-default, #f9f6f3)',
      /**
       * Use for emphasized warning color containers that draw attention.
       * Css custom property: --dt-colors-background-container-warning-emphasized. Default value: #f9f3ec.
       */
      Emphasized:
        'var(--dt-colors-background-container-warning-emphasized, #f9f3ec)',
      /**
       * Use for accentuated warning color containers with high contrast. Use sparingly.
       * Css custom property: --dt-colors-background-container-warning-accent. Default value: #eea53c.
       */
      Accent: 'var(--dt-colors-background-container-warning-accent, #eea53c)',
    },
    Critical: {
      /**
       * Use for default critical color containers.
       * Css custom property: --dt-colors-background-container-critical-default. Default value: #f9f1f2.
       */
      Default:
        'var(--dt-colors-background-container-critical-default, #f9f1f2)',
      /**
       * Use for emphasized critical color containers that draw attention.
       * Css custom property: --dt-colors-background-container-critical-emphasized. Default value: #f8e9e9.
       */
      Emphasized:
        'var(--dt-colors-background-container-critical-emphasized, #f8e9e9)',
      /**
       * Use for accentuated critical color containers with high contrast. Use sparingly.
       * Css custom property: --dt-colors-background-container-critical-accent. Default value: #c62239.
       */
      Accent: 'var(--dt-colors-background-container-critical-accent, #c62239)',
    },
  },
  Field: {
    Neutral: {
      /**
       * Use for disabled neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-disabled. Default value: #e4e5eb80.
       */
      Disabled: 'var(--dt-colors-background-field-neutral-disabled, #e4e5eb80)',
      /**
       * Use for default neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-default. Default value: #e4e5eb00.
       */
      Default: 'var(--dt-colors-background-field-neutral-default, #e4e5eb00)',
      /**
       * Use for hover interaction on default neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-default-hover. Default value: #dadbe4.
       */
      DefaultHover:
        'var(--dt-colors-background-field-neutral-default-hover, #dadbe4)',
      /**
       * Use for click interaction on default neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-default-active. Default value: #d0d1dc.
       */
      DefaultActive:
        'var(--dt-colors-background-field-neutral-default-active, #d0d1dc)',
      /**
       * Use for emphasized neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-emphasized. Default value: #e4e5eb.
       */
      Emphasized:
        'var(--dt-colors-background-field-neutral-emphasized, #e4e5eb)',
      /**
       * Use for hover interaction on emphasized neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-emphasized-hover. Default value: #dadbe4.
       */
      EmphasizedHover:
        'var(--dt-colors-background-field-neutral-emphasized-hover, #dadbe4)',
      /**
       * Use for click interaction on emphasized neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-emphasized-active. Default value: #d0d1dc.
       */
      EmphasizedActive:
        'var(--dt-colors-background-field-neutral-emphasized-active, #d0d1dc)',
      /**
       * Use for accentuated neutral fields. Use sparingly.
       * Css custom property: --dt-colors-background-field-neutral-accent. Default value: #5b5c81.
       */
      Accent: 'var(--dt-colors-background-field-neutral-accent, #5b5c81)',
      /**
       * Use for hover interaction on accentuated neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-accent-hover. Default value: #4d4e72.
       */
      AccentHover:
        'var(--dt-colors-background-field-neutral-accent-hover, #4d4e72)',
      /**
       * Use for click interaction on accentuated neutral fields.
       * Css custom property: --dt-colors-background-field-neutral-accent-active. Default value: #404164.
       */
      AccentActive:
        'var(--dt-colors-background-field-neutral-accent-active, #404164)',
    },
    Primary: {
      /**
       * Use for disabled primary fields.
       * Css custom property: --dt-colors-background-field-primary-disabled. Default value: #e4e5eb80.
       */
      Disabled: 'var(--dt-colors-background-field-primary-disabled, #e4e5eb80)',
      /**
       * Use for default primary fields.
       * Css custom property: --dt-colors-background-field-primary-default. Default value: #e1e5f700.
       */
      Default: 'var(--dt-colors-background-field-primary-default, #e1e5f700)',
      /**
       * Use for hover interaction on default primary fields.
       * Css custom property: --dt-colors-background-field-primary-default-hover. Default value: #d5dbf6.
       */
      DefaultHover:
        'var(--dt-colors-background-field-primary-default-hover, #d5dbf6)',
      /**
       * Use for click interaction on default primary fields.
       * Css custom property: --dt-colors-background-field-primary-default-active. Default value: #c9d1f4.
       */
      DefaultActive:
        'var(--dt-colors-background-field-primary-default-active, #c9d1f4)',
      /**
       * Use for emphasized primary fields.
       * Css custom property: --dt-colors-background-field-primary-emphasized. Default value: #e1e5f7.
       */
      Emphasized:
        'var(--dt-colors-background-field-primary-emphasized, #e1e5f7)',
      /**
       * Use for hover interaction on emphasized primary fields.
       * Css custom property: --dt-colors-background-field-primary-emphasized-hover. Default value: #d5dbf6.
       */
      EmphasizedHover:
        'var(--dt-colors-background-field-primary-emphasized-hover, #d5dbf6)',
      /**
       * Use for click interaction on emphasized primary fields.
       * Css custom property: --dt-colors-background-field-primary-emphasized-active. Default value: #c9d1f4.
       */
      EmphasizedActive:
        'var(--dt-colors-background-field-primary-emphasized-active, #c9d1f4)',
      /**
       * Use for accentuated primary fields. Use sparingly.
       * Css custom property: --dt-colors-background-field-primary-accent. Default value: #474fcf.
       */
      Accent: 'var(--dt-colors-background-field-primary-accent, #474fcf)',
      /**
       * Use for hover interaction on accentuated primary fields.
       * Css custom property: --dt-colors-background-field-primary-accent-hover. Default value: #3b3fbe.
       */
      AccentHover:
        'var(--dt-colors-background-field-primary-accent-hover, #3b3fbe)',
      /**
       * Use for click interaction on accentuated primary fields.
       * Css custom property: --dt-colors-background-field-primary-accent-active. Default value: #312dad.
       */
      AccentActive:
        'var(--dt-colors-background-field-primary-accent-active, #312dad)',
    },
    Success: {
      /**
       * Use for disabled success fields.
       * Css custom property: --dt-colors-background-field-success-disabled. Default value: #e4e5eb80.
       */
      Disabled: 'var(--dt-colors-background-field-success-disabled, #e4e5eb80)',
      /**
       * Use for default success fields.
       * Css custom property: --dt-colors-background-field-success-default. Default value: #e0e7e600.
       */
      Default: 'var(--dt-colors-background-field-success-default, #e0e7e600)',
      /**
       * Use for hover interaction on default success fields.
       * Css custom property: --dt-colors-background-field-success-default-hover. Default value: #d3dedd.
       */
      DefaultHover:
        'var(--dt-colors-background-field-success-default-hover, #d3dedd)',
      /**
       * Use for click interaction on default success fields.
       * Css custom property: --dt-colors-background-field-success-default-active. Default value: #c7d5d3.
       */
      DefaultActive:
        'var(--dt-colors-background-field-success-default-active, #c7d5d3)',
      /**
       * Use for emphasized success fields.
       * Css custom property: --dt-colors-background-field-success-emphasized. Default value: #e0e7e6.
       */
      Emphasized:
        'var(--dt-colors-background-field-success-emphasized, #e0e7e6)',
      /**
       * Use for hover interaction on emphasized success fields.
       * Css custom property: --dt-colors-background-field-success-emphasized-hover. Default value: #d3dedd.
       */
      EmphasizedHover:
        'var(--dt-colors-background-field-success-emphasized-hover, #d3dedd)',
      /**
       * Use for click interaction on emphasized success fields.
       * Css custom property: --dt-colors-background-field-success-emphasized-active. Default value: #c7d5d3.
       */
      EmphasizedActive:
        'var(--dt-colors-background-field-success-emphasized-active, #c7d5d3)',
      /**
       * Use for accentuated success fields. Use sparingly.
       * Css custom property: --dt-colors-background-field-success-accent. Default value: #2f6862.
       */
      Accent: 'var(--dt-colors-background-field-success-accent, #2f6862)',
      /**
       * Use for hover interaction on accentuated success fields.
       * Css custom property: --dt-colors-background-field-success-accent-hover. Default value: #1f5a54.
       */
      AccentHover:
        'var(--dt-colors-background-field-success-accent-hover, #1f5a54)',
      /**
       * Use for click interaction on accentuated success fields.
       * Css custom property: --dt-colors-background-field-success-accent-active. Default value: #0d4c47.
       */
      AccentActive:
        'var(--dt-colors-background-field-success-accent-active, #0d4c47)',
    },
    Warning: {
      /**
       * Use for disabled warning fields.
       * Css custom property: --dt-colors-background-field-warning-disabled. Default value: #e4e5eb80.
       */
      Disabled: 'var(--dt-colors-background-field-warning-disabled, #e4e5eb80)',
      /**
       * Use for default warning fields.
       * Css custom property: --dt-colors-background-field-warning-default. Default value: #f9f0e500.
       */
      Default: 'var(--dt-colors-background-field-warning-default, #f9f0e500)',
      /**
       * Use for hover interaction on default warning fields.
       * Css custom property: --dt-colors-background-field-warning-default-hover. Default value: #f9ebdb.
       */
      DefaultHover:
        'var(--dt-colors-background-field-warning-default-hover, #f9ebdb)',
      /**
       * Use for click interaction on default warning fields.
       * Css custom property: --dt-colors-background-field-warning-default-active. Default value: #f9e6d0.
       */
      DefaultActive:
        'var(--dt-colors-background-field-warning-default-active, #f9e6d0)',
      /**
       * Use for emphasized warning fields.
       * Css custom property: --dt-colors-background-field-warning-emphasized. Default value: #f9f0e5.
       */
      Emphasized:
        'var(--dt-colors-background-field-warning-emphasized, #f9f0e5)',
      /**
       * Use for hover interaction on emphasized warning fields.
       * Css custom property: --dt-colors-background-field-warning-emphasized-hover. Default value: #f9ebdb.
       */
      EmphasizedHover:
        'var(--dt-colors-background-field-warning-emphasized-hover, #f9ebdb)',
      /**
       * Use for click interaction on emphasized warning fields.
       * Css custom property: --dt-colors-background-field-warning-emphasized-active. Default value: #f9e6d0.
       */
      EmphasizedActive:
        'var(--dt-colors-background-field-warning-emphasized-active, #f9e6d0)',
      /**
       * Use for accentuated warning fields. Use sparingly.
       * Css custom property: --dt-colors-background-field-warning-accent. Default value: #eea53c.
       */
      Accent: 'var(--dt-colors-background-field-warning-accent, #eea53c)',
      /**
       * Use for hover interaction on accentuated warning fields.
       * Css custom property: --dt-colors-background-field-warning-accent-hover. Default value: #ffb54f.
       */
      AccentHover:
        'var(--dt-colors-background-field-warning-accent-hover, #ffb54f)',
      /**
       * Use for click interaction on accentuated warning fields.
       * Css custom property: --dt-colors-background-field-warning-accent-active. Default value: #ffc76d.
       */
      AccentActive:
        'var(--dt-colors-background-field-warning-accent-active, #ffc76d)',
    },
    Critical: {
      /**
       * Use for disabled critical fields.
       * Css custom property: --dt-colors-background-field-critical-disabled. Default value: #e4e5eb80.
       */
      Disabled:
        'var(--dt-colors-background-field-critical-disabled, #e4e5eb80)',
      /**
       * Use for default critical fields.
       * Css custom property: --dt-colors-background-field-critical-default. Default value: #f8e1e100.
       */
      Default: 'var(--dt-colors-background-field-critical-default, #f8e1e100)',
      /**
       * Use for hover interaction on default critical fields.
       * Css custom property: --dt-colors-background-field-critical-default-hover. Default value: #f6d6d5.
       */
      DefaultHover:
        'var(--dt-colors-background-field-critical-default-hover, #f6d6d5)',
      /**
       * Use for click interaction on default critical fields.
       * Css custom property: --dt-colors-background-field-critical-default-active. Default value: #f5cac9.
       */
      DefaultActive:
        'var(--dt-colors-background-field-critical-default-active, #f5cac9)',
      /**
       * Use for emphasized critical fields.
       * Css custom property: --dt-colors-background-field-critical-emphasized. Default value: #f8e1e1.
       */
      Emphasized:
        'var(--dt-colors-background-field-critical-emphasized, #f8e1e1)',
      /**
       * Use for hover interaction on emphasized critical fields.
       * Css custom property: --dt-colors-background-field-critical-emphasized-hover. Default value: #f6d6d5.
       */
      EmphasizedHover:
        'var(--dt-colors-background-field-critical-emphasized-hover, #f6d6d5)',
      /**
       * Use for click interaction on emphasized critical fields.
       * Css custom property: --dt-colors-background-field-critical-emphasized-active. Default value: #f5cac9.
       */
      EmphasizedActive:
        'var(--dt-colors-background-field-critical-emphasized-active, #f5cac9)',
      /**
       * Use for accentuated critical fields. Use sparingly.
       * Css custom property: --dt-colors-background-field-critical-accent. Default value: #c62239.
       */
      Accent: 'var(--dt-colors-background-field-critical-accent, #c62239)',
      /**
       * Use for hover interaction on accentuated critical fields.
       * Css custom property: --dt-colors-background-field-critical-accent-hover. Default value: #b4002b.
       */
      AccentHover:
        'var(--dt-colors-background-field-critical-accent-hover, #b4002b)',
      /**
       * Use for click interaction on accentuated critical fields.
       * Css custom property: --dt-colors-background-field-critical-accent-active. Default value: #a2001d.
       */
      AccentActive:
        'var(--dt-colors-background-field-critical-accent-active, #a2001d)',
    },
  },
  Shell: {
    /**
     * Use for the shell background.
     * Css custom property: --dt-colors-background-shell-default. Default value: #f2f2f5.
     */
    Default: 'var(--dt-colors-background-shell-default, #f2f2f5)',
  },
};
const Border = {
  Neutral: {
    OnAccent: {
      /**
       * Use as border color for disabled elements in accentuated context.
       * Css custom property: --dt-colors-border-neutral-on-accent-disabled. Default value: #f3f3f633.
       */
      Disabled: 'var(--dt-colors-border-neutral-on-accent-disabled, #f3f3f633)',
      /**
       * Use as border color for elements in accentuated context.
       * Css custom property: --dt-colors-border-neutral-on-accent-default. Default value: #f3f3f6.
       */
      Default: 'var(--dt-colors-border-neutral-on-accent-default, #f3f3f6)',
      /**
       * Use as border color for elements in accentuated context on hover interaction.
       * Css custom property: --dt-colors-border-neutral-on-accent-default-hover. Default value: #f3f3f6cc.
       */
      DefaultHover:
        'var(--dt-colors-border-neutral-on-accent-default-hover, #f3f3f6cc)',
      /**
       * Use as border color for elements in accentuated context on click interaction.
       * Css custom property: --dt-colors-border-neutral-on-accent-default-active. Default value: #f3f3f699.
       */
      DefaultActive:
        'var(--dt-colors-border-neutral-on-accent-default-active, #f3f3f699)',
    },
    /**
     * Use as the default border color in a disabled state.
     * Css custom property: --dt-colors-border-neutral-disabled. Default value: #dadbe480.
     */
    Disabled: 'var(--dt-colors-border-neutral-disabled, #dadbe480)',
    /**
     * Use as the default border color.
     * Css custom property: --dt-colors-border-neutral-default. Default value: #dadbe4.
     */
    Default: 'var(--dt-colors-border-neutral-default, #dadbe4)',
    /**
     * Use as default border color on hover interaction.
     * Css custom property: --dt-colors-border-neutral-default-hover. Default value: #d0d1dc.
     */
    DefaultHover: 'var(--dt-colors-border-neutral-default-hover, #d0d1dc)',
    /**
     * Use as default border color on click interaction.
     * Css custom property: --dt-colors-border-neutral-default-active. Default value: #c6c7d5.
     */
    DefaultActive: 'var(--dt-colors-border-neutral-default-active, #c6c7d5)',
    /**
     * Use as the border color of accentuated elements.
     * Css custom property: --dt-colors-border-neutral-accent. Default value: #595a7d.
     */
    Accent: 'var(--dt-colors-border-neutral-accent, #595a7d)',
    /**
     * Use as border color of accentuated elements on hover interaction.
     * Css custom property: --dt-colors-border-neutral-accent-hover. Default value: #434465.
     */
    AccentHover: 'var(--dt-colors-border-neutral-accent-hover, #434465)',
    /**
     * Use as border color of accentuated elements on click interaction.
     * Css custom property: --dt-colors-border-neutral-accent-active. Default value: #2f2f4f.
     */
    AccentActive: 'var(--dt-colors-border-neutral-accent-active, #2f2f4f)',
    /**
     * Use as border color of subtle elements.
     * Css custom property: --dt-colors-border-neutral-subdued. Default value: #e4e5eb.
     */
    Subdued: 'var(--dt-colors-border-neutral-subdued, #e4e5eb)',
    /**
     * Use as border color of subtle elements on hover interaction.
     * Css custom property: --dt-colors-border-neutral-subdued-hover. Default value: #d0d1dc.
     */
    SubduedHover: 'var(--dt-colors-border-neutral-subdued-hover, #d0d1dc)',
    /**
     * Use for click interactions on subtle elements.
     * Css custom property: --dt-colors-border-neutral-subdued-active. Default value: #c6c7d5.
     */
    SubduedActive: 'var(--dt-colors-border-neutral-subdued-active, #c6c7d5)',
  },
  Primary: {
    OnAccent: {
      /**
       * Use as border color for disabled elements in primary accentuated context.
       * Css custom property: --dt-colors-border-primary-on-accent-disabled. Default value: #f4f4fb33.
       */
      Disabled: 'var(--dt-colors-border-primary-on-accent-disabled, #f4f4fb33)',
      /**
       * Use as border color for elements in primary accentuated context.
       * Css custom property: --dt-colors-border-primary-on-accent-default. Default value: #f4f4fb.
       */
      Default: 'var(--dt-colors-border-primary-on-accent-default, #f4f4fb)',
      /**
       * Use as border color for elements in primary accentuated context on hover interaction.
       * Css custom property: --dt-colors-border-primary-on-accent-default-hover. Default value: #f4f4fbcc.
       */
      DefaultHover:
        'var(--dt-colors-border-primary-on-accent-default-hover, #f4f4fbcc)',
      /**
       * Use as border color for elements in primary accentuated context on click interaction.
       * Css custom property: --dt-colors-border-primary-on-accent-default-active. Default value: #f4f4fb99.
       */
      DefaultActive:
        'var(--dt-colors-border-primary-on-accent-default-active, #f4f4fb99)',
    },
    /**
     * Use as border primary color in a disabled state.
     * Css custom property: --dt-colors-border-primary-disabled. Default value: #dadbe480.
     */
    Disabled: 'var(--dt-colors-border-primary-disabled, #dadbe480)',
    /**
     * Use as the default primary border color.
     * Css custom property: --dt-colors-border-primary-default. Default value: #d5dbf6.
     */
    Default: 'var(--dt-colors-border-primary-default, #d5dbf6)',
    /**
     * Use as default border primary color on hover interaction.
     * Css custom property: --dt-colors-border-primary-default-hover. Default value: #c9d1f4.
     */
    DefaultHover: 'var(--dt-colors-border-primary-default-hover, #c9d1f4)',
    /**
     * Use as default border primary color on click interaction.
     * Css custom property: --dt-colors-border-primary-default-active. Default value: #bdc7f2.
     */
    DefaultActive: 'var(--dt-colors-border-primary-default-active, #bdc7f2)',
    /**
     * Use as the border color of primary accentuated elements.
     * Css custom property: --dt-colors-border-primary-accent. Default value: #464cce.
     */
    Accent: 'var(--dt-colors-border-primary-accent, #464cce)',
    /**
     * Use as border color of primary accentuated elements on hover interaction.
     * Css custom property: --dt-colors-border-primary-accent-hover. Default value: #3431b3.
     */
    AccentHover: 'var(--dt-colors-border-primary-accent-hover, #3431b3)',
    /**
     * Use as border color of primary accentuated elements on click interaction.
     * Css custom property: --dt-colors-border-primary-accent-active. Default value: #250f98.
     */
    AccentActive: 'var(--dt-colors-border-primary-accent-active, #250f98)',
  },
  Success: {
    OnAccent: {
      /**
       * Use as border color for disabled elements in success accentuated context.
       * Css custom property: --dt-colors-border-success-on-accent-disabled. Default value: #f1f4f433.
       */
      Disabled: 'var(--dt-colors-border-success-on-accent-disabled, #f1f4f433)',
      /**
       * Use as border color for elements in success accentuated context.
       * Css custom property: --dt-colors-border-success-on-accent-default. Default value: #f1f4f4.
       */
      Default: 'var(--dt-colors-border-success-on-accent-default, #f1f4f4)',
      /**
       * Use as border color for elements in success accentuated context on hover interaction.
       * Css custom property: --dt-colors-border-success-on-accent-default-hover. Default value: #f1f4f4cc.
       */
      DefaultHover:
        'var(--dt-colors-border-success-on-accent-default-hover, #f1f4f4cc)',
      /**
       * Use as border color for elements in success accentuated context on click interaction.
       * Css custom property: --dt-colors-border-success-on-accent-default-active. Default value: #f1f4f499.
       */
      DefaultActive:
        'var(--dt-colors-border-success-on-accent-default-active, #f1f4f499)',
    },
    /**
     * Use as border success color in a disabled state.
     * Css custom property: --dt-colors-border-success-disabled. Default value: #dadbe480.
     */
    Disabled: 'var(--dt-colors-border-success-disabled, #dadbe480)',
    /**
     * Use as the default success border color.
     * Css custom property: --dt-colors-border-success-default. Default value: #d3dedd.
     */
    Default: 'var(--dt-colors-border-success-default, #d3dedd)',
    /**
     * Use as default border success color on hover interaction.
     * Css custom property: --dt-colors-border-success-default-hover. Default value: #c7d5d3.
     */
    DefaultHover: 'var(--dt-colors-border-success-default-hover, #c7d5d3)',
    /**
     * Use as default border success color on click interaction.
     * Css custom property: --dt-colors-border-success-default-active. Default value: #bbccc9.
     */
    DefaultActive: 'var(--dt-colors-border-success-default-active, #bbccc9)',
    /**
     * Use as the border color of success accentuated elements.
     * Css custom property: --dt-colors-border-success-accent. Default value: #2d6761.
     */
    Accent: 'var(--dt-colors-border-success-accent, #2d6761)',
    /**
     * Use as border color of success accentuated elements on hover interaction.
     * Css custom property: --dt-colors-border-success-accent-hover. Default value: #12504b.
     */
    AccentHover: 'var(--dt-colors-border-success-accent-hover, #12504b)',
    /**
     * Use as border color of success accentuated elements on click interaction.
     * Css custom property: --dt-colors-border-success-accent-active. Default value: #003b36.
     */
    AccentActive: 'var(--dt-colors-border-success-accent-active, #003b36)',
  },
  Warning: {
    OnAccent: {
      /**
       * Use as border color for disabled elements in warning accentuated context.
       * Css custom property: --dt-colors-border-warning-on-accent-disabled. Default value: #27202433.
       */
      Disabled: 'var(--dt-colors-border-warning-on-accent-disabled, #27202433)',
      /**
       * Use as border color for elements in warning accentuated context.
       * Css custom property: --dt-colors-border-warning-on-accent-default. Default value: #272024.
       */
      Default: 'var(--dt-colors-border-warning-on-accent-default, #272024)',
      /**
       * Use as border color for elements in warning accentuated context on hover interaction.
       * Css custom property: --dt-colors-border-warning-on-accent-default-hover. Default value: #272024cc.
       */
      DefaultHover:
        'var(--dt-colors-border-warning-on-accent-default-hover, #272024cc)',
      /**
       * Use as border color for elements in warning accentuated context on click interaction.
       * Css custom property: --dt-colors-border-warning-on-accent-default-active. Default value: #27202499.
       */
      DefaultActive:
        'var(--dt-colors-border-warning-on-accent-default-active, #27202499)',
    },
    /**
     * Use as border warning color in a disabled state.
     * Css custom property: --dt-colors-border-warning-disabled. Default value: #dadbe480.
     */
    Disabled: 'var(--dt-colors-border-warning-disabled, #dadbe480)',
    /**
     * Use as the default warning border color.
     * Css custom property: --dt-colors-border-warning-default. Default value: #f9ebdb.
     */
    Default: 'var(--dt-colors-border-warning-default, #f9ebdb)',
    /**
     * Use as default border warning color on hover interaction.
     * Css custom property: --dt-colors-border-warning-default-hover. Default value: #f9e6d0.
     */
    DefaultHover: 'var(--dt-colors-border-warning-default-hover, #f9e6d0)',
    /**
     * Use as default border warning color on click interaction.
     * Css custom property: --dt-colors-border-warning-default-active. Default value: #f9e1c6.
     */
    DefaultActive: 'var(--dt-colors-border-warning-default-active, #f9e1c6)',
    /**
     * Use as the border color of warning accentuated elements.
     * Css custom property: --dt-colors-border-warning-accent. Default value: #855400.
     */
    Accent: 'var(--dt-colors-border-warning-accent, #855400)',
    /**
     * Use as border color of warning accentuated elements on hover interaction.
     * Css custom property: --dt-colors-border-warning-accent-hover. Default value: #6d3d00.
     */
    AccentHover: 'var(--dt-colors-border-warning-accent-hover, #6d3d00)',
    /**
     * Use as border color of warning accentuated elements on click interaction.
     * Css custom property: --dt-colors-border-warning-accent-active. Default value: #512a00.
     */
    AccentActive: 'var(--dt-colors-border-warning-accent-active, #512a00)',
  },
  Critical: {
    OnAccent: {
      /**
       * Use as border color for disabled elements in critical accentuated context.
       * Css custom property: --dt-colors-border-critical-on-accent-disabled. Default value: #f9f1f333.
       */
      Disabled:
        'var(--dt-colors-border-critical-on-accent-disabled, #f9f1f333)',
      /**
       * Use as border color for elements in critical accentuated context.
       * Css custom property: --dt-colors-border-critical-on-accent-default. Default value: #f9f1f3.
       */
      Default: 'var(--dt-colors-border-critical-on-accent-default, #f9f1f3)',
      /**
       * Use as border color for elements in critical accentuated context on hover interaction.
       * Css custom property: --dt-colors-border-critical-on-accent-default-hover. Default value: #f9f1f3cc.
       */
      DefaultHover:
        'var(--dt-colors-border-critical-on-accent-default-hover, #f9f1f3cc)',
      /**
       * Use as border color for elements in critical accentuated context on click interaction.
       * Css custom property: --dt-colors-border-critical-on-accent-default-active. Default value: #f9f1f399.
       */
      DefaultActive:
        'var(--dt-colors-border-critical-on-accent-default-active, #f9f1f399)',
    },
    /**
     * Use as border critical color in a disabled state.
     * Css custom property: --dt-colors-border-critical-disabled. Default value: #dadbe480.
     */
    Disabled: 'var(--dt-colors-border-critical-disabled, #dadbe480)',
    /**
     * Use as the default critical border color.
     * Css custom property: --dt-colors-border-critical-default. Default value: #f6d6d5.
     */
    Default: 'var(--dt-colors-border-critical-default, #f6d6d5)',
    /**
     * Use as default border critical color on hover interaction.
     * Css custom property: --dt-colors-border-critical-default-hover. Default value: #f5cac9.
     */
    DefaultHover: 'var(--dt-colors-border-critical-default-hover, #f5cac9)',
    /**
     * Use as default border critical color on click interaction.
     * Css custom property: --dt-colors-border-critical-default-active. Default value: #f3bebd.
     */
    DefaultActive: 'var(--dt-colors-border-critical-default-active, #f3bebd)',
    /**
     * Use as the border color of critical accentuated elements.
     * Css custom property: --dt-colors-border-critical-accent. Default value: #bb0731.
     */
    Accent: 'var(--dt-colors-border-critical-accent, #bb0731)',
    /**
     * Use as border color of critical accentuated elements on hover interaction.
     * Css custom property: --dt-colors-border-critical-accent-hover. Default value: #9b001e.
     */
    AccentHover: 'var(--dt-colors-border-critical-accent-hover, #9b001e)',
    /**
     * Use as border color of critical accentuated elements on click interaction.
     * Css custom property: --dt-colors-border-critical-accent-active. Default value: #750013.
     */
    AccentActive: 'var(--dt-colors-border-critical-accent-active, #750013)',
  },
};
const Text = {
  Neutral: {
    OnAccent: {
      /**
       * Use as text color for disabled elements in accentuated context.
       * Css custom property: --dt-colors-text-neutral-on-accent-disabled. Default value: #f3f3f680.
       */
      Disabled: 'var(--dt-colors-text-neutral-on-accent-disabled, #f3f3f680)',
      /**
       * Use as text color for elements in accentuated context.
       * Css custom property: --dt-colors-text-neutral-on-accent-default. Default value: #f3f3f6.
       */
      Default: 'var(--dt-colors-text-neutral-on-accent-default, #f3f3f6)',
      /**
       * Use as text color for elements in accentuated context on hover interaction.
       * Css custom property: --dt-colors-text-neutral-on-accent-default-hover. Default value: #f3f3f6cc.
       */
      DefaultHover:
        'var(--dt-colors-text-neutral-on-accent-default-hover, #f3f3f6cc)',
      /**
       * Use as text color for elements in accentuated context on click interaction.
       * Css custom property: --dt-colors-text-neutral-on-accent-default-active. Default value: #f3f3f699.
       */
      DefaultActive:
        'var(--dt-colors-text-neutral-on-accent-default-active, #f3f3f699)',
    },
    /**
     * Use for text color on disabled state.
     * Css custom property: --dt-colors-text-neutral-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-text-neutral-disabled, #595a7d80)',
    /**
     * Use for subtle, understated text color.
     * Css custom property: --dt-colors-text-neutral-subdued. Default value: #595a7d.
     */
    Subdued: 'var(--dt-colors-text-neutral-subdued, #595a7d)',
    /**
     * Use for subtle, understated text color on hover interaction.
     * Css custom property: --dt-colors-text-neutral-subdued-hover. Default value: #434465.
     */
    SubduedHover: 'var(--dt-colors-text-neutral-subdued-hover, #434465)',
    /**
     * Use for subtle, understated text color on click interaction.
     * Css custom property: --dt-colors-text-neutral-subdued-active. Default value: #2f2f4f.
     */
    SubduedActive: 'var(--dt-colors-text-neutral-subdued-active, #2f2f4f)',
    /**
     * Use as the default text color.
     * Css custom property: --dt-colors-text-neutral-default. Default value: #2f2f4f.
     */
    Default: 'var(--dt-colors-text-neutral-default, #2f2f4f)',
    /**
     * Use as the default text color on hover interaction.
     * Css custom property: --dt-colors-text-neutral-default-hover. Default value: #434465.
     */
    DefaultHover: 'var(--dt-colors-text-neutral-default-hover, #434465)',
    /**
     * Use as the default text color on click interaction.
     * Css custom property: --dt-colors-text-neutral-default-active. Default value: #595a7d.
     */
    DefaultActive: 'var(--dt-colors-text-neutral-default-active, #595a7d)',
  },
  Primary: {
    OnAccent: {
      /**
       * Use as text color for disabled elements in primary accentuated context.
       * Css custom property: --dt-colors-text-primary-on-accent-disabled. Default value: #f4f4fb80.
       */
      Disabled: 'var(--dt-colors-text-primary-on-accent-disabled, #f4f4fb80)',
      /**
       * Use as text color for elements in primary accentuated context.
       * Css custom property: --dt-colors-text-primary-on-accent-default. Default value: #f4f4fb.
       */
      Default: 'var(--dt-colors-text-primary-on-accent-default, #f4f4fb)',
      /**
       * Use as text color for elements in primary accentuated context on hover interaction.
       * Css custom property: --dt-colors-text-primary-on-accent-default-hover. Default value: #f4f4fbcc.
       */
      DefaultHover:
        'var(--dt-colors-text-primary-on-accent-default-hover, #f4f4fbcc)',
      /**
       * Use as text color for elements in primary accentuated context on click interaction.
       * Css custom property: --dt-colors-text-primary-on-accent-default-active. Default value: #f4f4fb99.
       */
      DefaultActive:
        'var(--dt-colors-text-primary-on-accent-default-active, #f4f4fb99)',
    },
    /**
     * Use for primary text color on disabled state.
     * Css custom property: --dt-colors-text-primary-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-text-primary-disabled, #595a7d80)',
    /**
     * Use as the default primary text color.
     * Css custom property: --dt-colors-text-primary-default. Default value: #464cce.
     */
    Default: 'var(--dt-colors-text-primary-default, #464cce)',
    /**
     * Use as the default primary text color on hover interaction.
     * Css custom property: --dt-colors-text-primary-default-hover. Default value: #3431b3.
     */
    DefaultHover: 'var(--dt-colors-text-primary-default-hover, #3431b3)',
    /**
     * Use as the default primary text color on click interaction.
     * Css custom property: --dt-colors-text-primary-default-active. Default value: #250f98.
     */
    DefaultActive: 'var(--dt-colors-text-primary-default-active, #250f98)',
  },
  Success: {
    OnAccent: {
      /**
       * Use as text color for disabled elements in success accentuated context.
       * Css custom property: --dt-colors-text-success-on-accent-disabled. Default value: #f1f4f480.
       */
      Disabled: 'var(--dt-colors-text-success-on-accent-disabled, #f1f4f480)',
      /**
       * Use as text color for elements in success accentuated context.
       * Css custom property: --dt-colors-text-success-on-accent-default. Default value: #f1f4f4.
       */
      Default: 'var(--dt-colors-text-success-on-accent-default, #f1f4f4)',
      /**
       * Use as text color for elements in success accentuated context on hover interaction.
       * Css custom property: --dt-colors-text-success-on-accent-default-hover. Default value: #f1f4f4cc.
       */
      DefaultHover:
        'var(--dt-colors-text-success-on-accent-default-hover, #f1f4f4cc)',
      /**
       * Use as text color for elements in success accentuated context on click interaction.
       * Css custom property: --dt-colors-text-success-on-accent-default-active. Default value: #f1f4f499.
       */
      DefaultActive:
        'var(--dt-colors-text-success-on-accent-default-active, #f1f4f499)',
    },
    /**
     * Use for success text color on disabled state.
     * Css custom property: --dt-colors-text-success-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-text-success-disabled, #595a7d80)',
    /**
     * Use as the default success text color.
     * Css custom property: --dt-colors-text-success-default. Default value: #2d6761.
     */
    Default: 'var(--dt-colors-text-success-default, #2d6761)',
    /**
     * Use as the default success text color on hover interaction.
     * Css custom property: --dt-colors-text-success-default-hover. Default value: #12504b.
     */
    DefaultHover: 'var(--dt-colors-text-success-default-hover, #12504b)',
    /**
     * Use as the default success text color on click interaction.
     * Css custom property: --dt-colors-text-success-default-active. Default value: #003b36.
     */
    DefaultActive: 'var(--dt-colors-text-success-default-active, #003b36)',
  },
  Warning: {
    OnAccent: {
      /**
       * Use as text color for disabled elements in warning accentuated context.
       * Css custom property: --dt-colors-text-warning-on-accent-disabled. Default value: #27202480.
       */
      Disabled: 'var(--dt-colors-text-warning-on-accent-disabled, #27202480)',
      /**
       * Use as text color for elements in warning accentuated context.
       * Css custom property: --dt-colors-text-warning-on-accent-default. Default value: #272024.
       */
      Default: 'var(--dt-colors-text-warning-on-accent-default, #272024)',
      /**
       * Use as text color for elements in warning accentuated context on hover interaction.
       * Css custom property: --dt-colors-text-warning-on-accent-default-hover. Default value: #272024cc.
       */
      DefaultHover:
        'var(--dt-colors-text-warning-on-accent-default-hover, #272024cc)',
      /**
       * Use as text color for elements in warning accentuated context on click interaction.
       * Css custom property: --dt-colors-text-warning-on-accent-default-active. Default value: #27202499.
       */
      DefaultActive:
        'var(--dt-colors-text-warning-on-accent-default-active, #27202499)',
    },
    /**
     * Use for warning text color on disabled state.
     * Css custom property: --dt-colors-text-warning-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-text-warning-disabled, #595a7d80)',
    /**
     * Use as the default warning text color.
     * Css custom property: --dt-colors-text-warning-default. Default value: #855400.
     */
    Default: 'var(--dt-colors-text-warning-default, #855400)',
    /**
     * Use as the default warning text color on hover interaction.
     * Css custom property: --dt-colors-text-warning-default-hover. Default value: #6d3d00.
     */
    DefaultHover: 'var(--dt-colors-text-warning-default-hover, #6d3d00)',
    /**
     * Use as the default warning text color on click interaction.
     * Css custom property: --dt-colors-text-warning-default-active. Default value: #512a00.
     */
    DefaultActive: 'var(--dt-colors-text-warning-default-active, #512a00)',
  },
  Critical: {
    OnAccent: {
      /**
       * Use as text color for disabled elements in critical accentuated context.
       * Css custom property: --dt-colors-text-critical-on-accent-disabled. Default value: #f9f1f380.
       */
      Disabled: 'var(--dt-colors-text-critical-on-accent-disabled, #f9f1f380)',
      /**
       * Use as text color for elements in critical accentuated context.
       * Css custom property: --dt-colors-text-critical-on-accent-default. Default value: #f9f1f3.
       */
      Default: 'var(--dt-colors-text-critical-on-accent-default, #f9f1f3)',
      /**
       * Use as text color for elements in critical accentuated context on hover interaction.
       * Css custom property: --dt-colors-text-critical-on-accent-default-hover. Default value: #f9f1f3cc.
       */
      DefaultHover:
        'var(--dt-colors-text-critical-on-accent-default-hover, #f9f1f3cc)',
      /**
       * Use as text color for elements in critical accentuated context on click interaction.
       * Css custom property: --dt-colors-text-critical-on-accent-default-active. Default value: #f9f1f399.
       */
      DefaultActive:
        'var(--dt-colors-text-critical-on-accent-default-active, #f9f1f399)',
    },
    /**
     * Use for critical text color on disabled state.
     * Css custom property: --dt-colors-text-critical-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-text-critical-disabled, #595a7d80)',
    /**
     * Use as the default critical text color.
     * Css custom property: --dt-colors-text-critical-default. Default value: #bb0731.
     */
    Default: 'var(--dt-colors-text-critical-default, #bb0731)',
    /**
     * Use as the default critical text color on hover interaction.
     * Css custom property: --dt-colors-text-critical-default-hover. Default value: #9b001e.
     */
    DefaultHover: 'var(--dt-colors-text-critical-default-hover, #9b001e)',
    /**
     * Use as the default critical text color on click interaction.
     * Css custom property: --dt-colors-text-critical-default-active. Default value: #750013.
     */
    DefaultActive: 'var(--dt-colors-text-critical-default-active, #750013)',
  },
};
const Icon = {
  Neutral: {
    OnAccent: {
      /**
       * Use as icon color for disabled elements in accentuated context.
       * Css custom property: --dt-colors-icon-neutral-on-accent-disabled. Default value: #f3f3f680.
       */
      Disabled: 'var(--dt-colors-icon-neutral-on-accent-disabled, #f3f3f680)',
      /**
       * Use as icon color for elements in accentuated context.
       * Css custom property: --dt-colors-icon-neutral-on-accent-default. Default value: #f3f3f6.
       */
      Default: 'var(--dt-colors-icon-neutral-on-accent-default, #f3f3f6)',
      /**
       * Use as icon color for elements in accentuated context on hover interaction.
       * Css custom property: --dt-colors-icon-neutral-on-accent-default-hover. Default value: #f3f3f6cc.
       */
      DefaultHover:
        'var(--dt-colors-icon-neutral-on-accent-default-hover, #f3f3f6cc)',
      /**
       * Use as icon color for elements in accentuated context on click interaction.
       * Css custom property: --dt-colors-icon-neutral-on-accent-default-active. Default value: #f3f3f699.
       */
      DefaultActive:
        'var(--dt-colors-icon-neutral-on-accent-default-active, #f3f3f699)',
    },
    /**
     * Use for icon color on disabled state.
     * Css custom property: --dt-colors-icon-neutral-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-icon-neutral-disabled, #595a7d80)',
    /**
     * Use for subtle, understated icon color.
     * Css custom property: --dt-colors-icon-neutral-subdued. Default value: #595a7d.
     */
    Subdued: 'var(--dt-colors-icon-neutral-subdued, #595a7d)',
    /**
     * Use for subtle, understated icon color on hover interaction.
     * Css custom property: --dt-colors-icon-neutral-subdued-hover. Default value: #434465.
     */
    SubduedHover: 'var(--dt-colors-icon-neutral-subdued-hover, #434465)',
    /**
     * Use for subtle, understated icon color on click interaction.
     * Css custom property: --dt-colors-icon-neutral-subdued-active. Default value: #2f2f4f.
     */
    SubduedActive: 'var(--dt-colors-icon-neutral-subdued-active, #2f2f4f)',
    /**
     * Use as the default icon color.
     * Css custom property: --dt-colors-icon-neutral-default. Default value: #2f2f4f.
     */
    Default: 'var(--dt-colors-icon-neutral-default, #2f2f4f)',
    /**
     * Use as the default icon color on hover interaction.
     * Css custom property: --dt-colors-icon-neutral-default-hover. Default value: #434465.
     */
    DefaultHover: 'var(--dt-colors-icon-neutral-default-hover, #434465)',
    /**
     * Use as the default icon color on click interaction.
     * Css custom property: --dt-colors-icon-neutral-default-active. Default value: #595a7d.
     */
    DefaultActive: 'var(--dt-colors-icon-neutral-default-active, #595a7d)',
  },
  Primary: {
    OnAccent: {
      /**
       * Use as icon color for disabled elements in primary accentuated context.
       * Css custom property: --dt-colors-icon-primary-on-accent-disabled. Default value: #f4f4fb80.
       */
      Disabled: 'var(--dt-colors-icon-primary-on-accent-disabled, #f4f4fb80)',
      /**
       * Use as icon color for elements in primary accentuated context.
       * Css custom property: --dt-colors-icon-primary-on-accent-default. Default value: #f4f4fb.
       */
      Default: 'var(--dt-colors-icon-primary-on-accent-default, #f4f4fb)',
      /**
       * Use as icon color for elements in primary accentuated context on hover interaction.
       * Css custom property: --dt-colors-icon-primary-on-accent-default-hover. Default value: #f4f4fbcc.
       */
      DefaultHover:
        'var(--dt-colors-icon-primary-on-accent-default-hover, #f4f4fbcc)',
      /**
       * Use as icon color for elements in primary accentuated context on click interaction.
       * Css custom property: --dt-colors-icon-primary-on-accent-default-active. Default value: #f4f4fb99.
       */
      DefaultActive:
        'var(--dt-colors-icon-primary-on-accent-default-active, #f4f4fb99)',
    },
    /**
     * Use for primary icon color on disabled state.
     * Css custom property: --dt-colors-icon-primary-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-icon-primary-disabled, #595a7d80)',
    /**
     * Use as the default primary icon color.
     * Css custom property: --dt-colors-icon-primary-default. Default value: #464cce.
     */
    Default: 'var(--dt-colors-icon-primary-default, #464cce)',
    /**
     * Use as the default primary icon color on hover interaction.
     * Css custom property: --dt-colors-icon-primary-default-hover. Default value: #3431b3.
     */
    DefaultHover: 'var(--dt-colors-icon-primary-default-hover, #3431b3)',
    /**
     * Use as the default primary icon color on click interaction.
     * Css custom property: --dt-colors-icon-primary-default-active. Default value: #250f98.
     */
    DefaultActive: 'var(--dt-colors-icon-primary-default-active, #250f98)',
  },
  Success: {
    OnAccent: {
      /**
       * Use as icon color for disabled elements in success accentuated context.
       * Css custom property: --dt-colors-icon-success-on-accent-disabled. Default value: #f1f4f480.
       */
      Disabled: 'var(--dt-colors-icon-success-on-accent-disabled, #f1f4f480)',
      /**
       * Use as icon color for elements in success accentuated context.
       * Css custom property: --dt-colors-icon-success-on-accent-default. Default value: #f1f4f4.
       */
      Default: 'var(--dt-colors-icon-success-on-accent-default, #f1f4f4)',
      /**
       * Use as icon color for elements in success accentuated context on hover interaction.
       * Css custom property: --dt-colors-icon-success-on-accent-default-hover. Default value: #f1f4f4cc.
       */
      DefaultHover:
        'var(--dt-colors-icon-success-on-accent-default-hover, #f1f4f4cc)',
      /**
       * Use as icon color for elements in success accentuated context on click interaction.
       * Css custom property: --dt-colors-icon-success-on-accent-default-active. Default value: #f1f4f499.
       */
      DefaultActive:
        'var(--dt-colors-icon-success-on-accent-default-active, #f1f4f499)',
    },
    /**
     * Use for success icon color on disabled state.
     * Css custom property: --dt-colors-icon-success-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-icon-success-disabled, #595a7d80)',
    /**
     * Use as the default success icon color.
     * Css custom property: --dt-colors-icon-success-default. Default value: #2d6761.
     */
    Default: 'var(--dt-colors-icon-success-default, #2d6761)',
    /**
     * Use as the default success icon color on hover interaction.
     * Css custom property: --dt-colors-icon-success-default-hover. Default value: #12504b.
     */
    DefaultHover: 'var(--dt-colors-icon-success-default-hover, #12504b)',
    /**
     * Use as the default success icon color on click interaction.
     * Css custom property: --dt-colors-icon-success-default-active. Default value: #003b36.
     */
    DefaultActive: 'var(--dt-colors-icon-success-default-active, #003b36)',
  },
  Warning: {
    OnAccent: {
      /**
       * Use as icon color for disabled elements in warning accentuated context.
       * Css custom property: --dt-colors-icon-warning-on-accent-disabled. Default value: #27202480.
       */
      Disabled: 'var(--dt-colors-icon-warning-on-accent-disabled, #27202480)',
      /**
       * Use as icon color for elements in warning accentuated context.
       * Css custom property: --dt-colors-icon-warning-on-accent-default. Default value: #272024.
       */
      Default: 'var(--dt-colors-icon-warning-on-accent-default, #272024)',
      /**
       * Use as icon color for elements in warning accentuated context on hover interaction.
       * Css custom property: --dt-colors-icon-warning-on-accent-default-hover. Default value: #272024cc.
       */
      DefaultHover:
        'var(--dt-colors-icon-warning-on-accent-default-hover, #272024cc)',
      /**
       * Use as icon color for elements in warning accentuated context on click interaction.
       * Css custom property: --dt-colors-icon-warning-on-accent-default-active. Default value: #27202499.
       */
      DefaultActive:
        'var(--dt-colors-icon-warning-on-accent-default-active, #27202499)',
    },
    /**
     * Use for warning icon color on disabled state.
     * Css custom property: --dt-colors-icon-warning-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-icon-warning-disabled, #595a7d80)',
    /**
     * Use as the default warning icon color.
     * Css custom property: --dt-colors-icon-warning-default. Default value: #855400.
     */
    Default: 'var(--dt-colors-icon-warning-default, #855400)',
    /**
     * Use as the default warning icon color on hover interaction.
     * Css custom property: --dt-colors-icon-warning-default-hover. Default value: #6d3d00.
     */
    DefaultHover: 'var(--dt-colors-icon-warning-default-hover, #6d3d00)',
    /**
     * Use as the default warning icon color on click interaction.
     * Css custom property: --dt-colors-icon-warning-default-active. Default value: #512a00.
     */
    DefaultActive: 'var(--dt-colors-icon-warning-default-active, #512a00)',
  },
  Critical: {
    OnAccent: {
      /**
       * Use as icon color for disabled elements in critical accentuated context.
       * Css custom property: --dt-colors-icon-critical-on-accent-disabled. Default value: #f9f1f380.
       */
      Disabled: 'var(--dt-colors-icon-critical-on-accent-disabled, #f9f1f380)',
      /**
       * Use as icon color for elements in critical accentuated context.
       * Css custom property: --dt-colors-icon-critical-on-accent-default. Default value: #f9f1f3.
       */
      Default: 'var(--dt-colors-icon-critical-on-accent-default, #f9f1f3)',
      /**
       * Use as icon color for elements in critical accentuated context on hover interaction.
       * Css custom property: --dt-colors-icon-critical-on-accent-default-hover. Default value: #f9f1f3cc.
       */
      DefaultHover:
        'var(--dt-colors-icon-critical-on-accent-default-hover, #f9f1f3cc)',
      /**
       * Use as icon color for elements in critical accentuated context on click interaction.
       * Css custom property: --dt-colors-icon-critical-on-accent-default-active. Default value: #f9f1f399.
       */
      DefaultActive:
        'var(--dt-colors-icon-critical-on-accent-default-active, #f9f1f399)',
    },
    /**
     * Use for critical icon color on disabled state.
     * Css custom property: --dt-colors-icon-critical-disabled. Default value: #595a7d80.
     */
    Disabled: 'var(--dt-colors-icon-critical-disabled, #595a7d80)',
    /**
     * Use as the default critical icon color.
     * Css custom property: --dt-colors-icon-critical-default. Default value: #bb0731.
     */
    Default: 'var(--dt-colors-icon-critical-default, #bb0731)',
    /**
     * Use as the default critical icon color on hover interaction.
     * Css custom property: --dt-colors-icon-critical-default-hover. Default value: #9b001e.
     */
    DefaultHover: 'var(--dt-colors-icon-critical-default-hover, #9b001e)',
    /**
     * Use as the default critical icon color on click interaction.
     * Css custom property: --dt-colors-icon-critical-default-active. Default value: #750013.
     */
    DefaultActive: 'var(--dt-colors-icon-critical-default-active, #750013)',
  },
};
const Syntax = {
  /**
   * Use to style 'Comment' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-comment. Default value: #545586.
   */
  Comment: 'var(--dt-colors-syntax-comment, #545586)',
  /**
   * Use to style 'String' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-string. Default value: #086467.
   */
  String: 'var(--dt-colors-syntax-string, #086467)',
  /**
   * Use to style 'Variable' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-variable. Default value: #2754b5.
   */
  Variable: 'var(--dt-colors-syntax-variable, #2754b5)',
  /**
   * Use to style 'Number' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-number. Default value: #aa0081.
   */
  Number: 'var(--dt-colors-syntax-number, #aa0081)',
  /**
   * Use to style 'Punctuation' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-punctuation. Default value: #8136a9.
   */
  Punctuation: 'var(--dt-colors-syntax-punctuation, #8136a9)',
  /**
   * Use to style 'Function' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-function. Default value: #2754b5.
   */
  Function: 'var(--dt-colors-syntax-function, #2754b5)',
  /**
   * Use to style 'Classname' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-classname. Default value: #2c2d4d.
   */
  Classname: 'var(--dt-colors-syntax-classname, #2c2d4d)',
  /**
   * Use to style 'Tag' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-tag. Default value: #b30926.
   */
  Tag: 'var(--dt-colors-syntax-tag, #b30926)',
  /**
   * Use to style 'Operators' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-operators. Default value: #8136a9.
   */
  Operators: 'var(--dt-colors-syntax-operators, #8136a9)',
  /**
   * Use to style 'Boolean' syntax on a code editor context.
   * Css custom property: --dt-colors-syntax-boolean. Default value: #973f00.
   */
  Boolean: 'var(--dt-colors-syntax-boolean, #973f00)',
};
const Charts = {
  Status: {
    Ideal: {
      /** Css custom property: --dt-colors-charts-status-ideal-default. Default value: #2f6862. */
      Default: 'var(--dt-colors-charts-status-ideal-default, #2f6862)',
    },
    Good: {
      /** Css custom property: --dt-colors-charts-status-good-default. Default value: #474fcf. */
      Default: 'var(--dt-colors-charts-status-good-default, #474fcf)',
    },
    Neutral: {
      /** Css custom property: --dt-colors-charts-status-neutral-default. Default value: #5b5c81. */
      Default: 'var(--dt-colors-charts-status-neutral-default, #5b5c81)',
    },
    Warning: {
      /** Css custom property: --dt-colors-charts-status-warning-default. Default value: #eea53c. */
      Default: 'var(--dt-colors-charts-status-warning-default, #eea53c)',
    },
    Critical: {
      /** Css custom property: --dt-colors-charts-status-critical-default. Default value: #c62239. */
      Default: 'var(--dt-colors-charts-status-critical-default, #c62239)',
    },
  },
  Categorical: {
    Color01: {
      /** Css custom property: --dt-colors-charts-categorical-color-01-default. Default value: #134fc9. */
      Default: 'var(--dt-colors-charts-categorical-color-01-default, #134fc9)',
    },
    Color02: {
      /** Css custom property: --dt-colors-charts-categorical-color-02-default. Default value: #2c2f3f. */
      Default: 'var(--dt-colors-charts-categorical-color-02-default, #2c2f3f)',
    },
    Color03: {
      /** Css custom property: --dt-colors-charts-categorical-color-03-default. Default value: #2a7453. */
      Default: 'var(--dt-colors-charts-categorical-color-03-default, #2a7453)',
    },
    Color04: {
      /** Css custom property: --dt-colors-charts-categorical-color-04-default. Default value: #d85a9f. */
      Default: 'var(--dt-colors-charts-categorical-color-04-default, #d85a9f)',
    },
    Color05: {
      /** Css custom property: --dt-colors-charts-categorical-color-05-default. Default value: #84859a. */
      Default: 'var(--dt-colors-charts-categorical-color-05-default, #84859a)',
    },
    Color06: {
      /** Css custom property: --dt-colors-charts-categorical-color-06-default. Default value: #a9780f. */
      Default: 'var(--dt-colors-charts-categorical-color-06-default, #a9780f)',
    },
    Color07: {
      /** Css custom property: --dt-colors-charts-categorical-color-07-default. Default value: #438fb1. */
      Default: 'var(--dt-colors-charts-categorical-color-07-default, #438fb1)',
    },
    Color08: {
      /** Css custom property: --dt-colors-charts-categorical-color-08-default. Default value: #8b6ecf. */
      Default: 'var(--dt-colors-charts-categorical-color-08-default, #8b6ecf)',
    },
    Color09: {
      /** Css custom property: --dt-colors-charts-categorical-color-09-default. Default value: #649438. */
      Default: 'var(--dt-colors-charts-categorical-color-09-default, #649438)',
    },
    Color10: {
      /** Css custom property: --dt-colors-charts-categorical-color-10-default. Default value: #904523. */
      Default: 'var(--dt-colors-charts-categorical-color-10-default, #904523)',
    },
    Color11: {
      /** Css custom property: --dt-colors-charts-categorical-color-11-default. Default value: #627cfe. */
      Default: 'var(--dt-colors-charts-categorical-color-11-default, #627cfe)',
    },
    Color12: {
      /** Css custom property: --dt-colors-charts-categorical-color-12-default. Default value: #cd3741. */
      Default: 'var(--dt-colors-charts-categorical-color-12-default, #cd3741)',
    },
    Color13: {
      /** Css custom property: --dt-colors-charts-categorical-color-13-default. Default value: #1c520a. */
      Default: 'var(--dt-colors-charts-categorical-color-13-default, #1c520a)',
    },
    Color14: {
      /** Css custom property: --dt-colors-charts-categorical-color-14-default. Default value: #d56b1a. */
      Default: 'var(--dt-colors-charts-categorical-color-14-default, #d56b1a)',
    },
    Color15: {
      /** Css custom property: --dt-colors-charts-categorical-color-15-default. Default value: #9033a3. */
      Default: 'var(--dt-colors-charts-categorical-color-15-default, #9033a3)',
    },
  },
  CategoricalThemed: {
    PurpleRain: {
      Color01: {
        /** Css custom property: --dt-colors-charts-categorical-themed-purple-rain-color-01-default. Default value: #9033a3. */
        Default:
          'var(--dt-colors-charts-categorical-themed-purple-rain-color-01-default, #9033a3)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-categorical-themed-purple-rain-color-02-default. Default value: #a9780f. */
        Default:
          'var(--dt-colors-charts-categorical-themed-purple-rain-color-02-default, #a9780f)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-categorical-themed-purple-rain-color-03-default. Default value: #d85a9f. */
        Default:
          'var(--dt-colors-charts-categorical-themed-purple-rain-color-03-default, #d85a9f)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-categorical-themed-purple-rain-color-04-default. Default value: #8b6ecf. */
        Default:
          'var(--dt-colors-charts-categorical-themed-purple-rain-color-04-default, #8b6ecf)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-categorical-themed-purple-rain-color-05-default. Default value: #904523. */
        Default:
          'var(--dt-colors-charts-categorical-themed-purple-rain-color-05-default, #904523)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-categorical-themed-purple-rain-color-06-default. Default value: #cd3741. */
        Default:
          'var(--dt-colors-charts-categorical-themed-purple-rain-color-06-default, #cd3741)',
      },
    },
    Swamps: {
      Color01: {
        /** Css custom property: --dt-colors-charts-categorical-themed-swamps-color-01-default. Default value: #006650. */
        Default:
          'var(--dt-colors-charts-categorical-themed-swamps-color-01-default, #006650)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-categorical-themed-swamps-color-02-default. Default value: #84859a. */
        Default:
          'var(--dt-colors-charts-categorical-themed-swamps-color-02-default, #84859a)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-categorical-themed-swamps-color-03-default. Default value: #649438. */
        Default:
          'var(--dt-colors-charts-categorical-themed-swamps-color-03-default, #649438)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-categorical-themed-swamps-color-04-default. Default value: #8f4624. */
        Default:
          'var(--dt-colors-charts-categorical-themed-swamps-color-04-default, #8f4624)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-categorical-themed-swamps-color-05-default. Default value: #2c2f3f. */
        Default:
          'var(--dt-colors-charts-categorical-themed-swamps-color-05-default, #2c2f3f)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-categorical-themed-swamps-color-06-default. Default value: #a9780f. */
        Default:
          'var(--dt-colors-charts-categorical-themed-swamps-color-06-default, #a9780f)',
      },
    },
    Fireplace: {
      Color01: {
        /** Css custom property: --dt-colors-charts-categorical-themed-fireplace-color-01-default. Default value: #ae132d. */
        Default:
          'var(--dt-colors-charts-categorical-themed-fireplace-color-01-default, #ae132d)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-categorical-themed-fireplace-color-02-default. Default value: #d85a9f. */
        Default:
          'var(--dt-colors-charts-categorical-themed-fireplace-color-02-default, #d85a9f)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-categorical-themed-fireplace-color-03-default. Default value: #d56b1a. */
        Default:
          'var(--dt-colors-charts-categorical-themed-fireplace-color-03-default, #d56b1a)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-categorical-themed-fireplace-color-04-default. Default value: #a9780f. */
        Default:
          'var(--dt-colors-charts-categorical-themed-fireplace-color-04-default, #a9780f)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-categorical-themed-fireplace-color-05-default. Default value: #904523. */
        Default:
          'var(--dt-colors-charts-categorical-themed-fireplace-color-05-default, #904523)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-categorical-themed-fireplace-color-06-default. Default value: #9033a3. */
        Default:
          'var(--dt-colors-charts-categorical-themed-fireplace-color-06-default, #9033a3)',
      },
    },
    BlueSteel: {
      Color01: {
        /** Css custom property: --dt-colors-charts-categorical-themed-blue-steel-color-01-default. Default value: #438fb1. */
        Default:
          'var(--dt-colors-charts-categorical-themed-blue-steel-color-01-default, #438fb1)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-categorical-themed-blue-steel-color-02-default. Default value: #84859a. */
        Default:
          'var(--dt-colors-charts-categorical-themed-blue-steel-color-02-default, #84859a)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-categorical-themed-blue-steel-color-03-default. Default value: #627cfe. */
        Default:
          'var(--dt-colors-charts-categorical-themed-blue-steel-color-03-default, #627cfe)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-categorical-themed-blue-steel-color-04-default. Default value: #8b6ecf. */
        Default:
          'var(--dt-colors-charts-categorical-themed-blue-steel-color-04-default, #8b6ecf)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-categorical-themed-blue-steel-color-05-default. Default value: #134fc9. */
        Default:
          'var(--dt-colors-charts-categorical-themed-blue-steel-color-05-default, #134fc9)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-categorical-themed-blue-steel-color-06-default. Default value: #2c2f3f. */
        Default:
          'var(--dt-colors-charts-categorical-themed-blue-steel-color-06-default, #2c2f3f)',
      },
    },
  },
  Logstatus: {
    Error: {
      /** Css custom property: --dt-colors-charts-logstatus-error-default. Default value: #cd3741. */
      Default: 'var(--dt-colors-charts-logstatus-error-default, #cd3741)',
    },
    Warning: {
      /** Css custom property: --dt-colors-charts-logstatus-warning-default. Default value: #a9780f. */
      Default: 'var(--dt-colors-charts-logstatus-warning-default, #a9780f)',
    },
    Info: {
      /** Css custom property: --dt-colors-charts-logstatus-info-default. Default value: #134fc9. */
      Default: 'var(--dt-colors-charts-logstatus-info-default, #134fc9)',
    },
    None: {
      /** Css custom property: --dt-colors-charts-logstatus-none-default. Default value: #2c2f3f. */
      Default: 'var(--dt-colors-charts-logstatus-none-default, #2c2f3f)',
    },
  },
  Loglevel: {
    Emergency: {
      /** Css custom property: --dt-colors-charts-loglevel-emergency-default. Default value: #ae132d. */
      Default: 'var(--dt-colors-charts-loglevel-emergency-default, #ae132d)',
    },
    Error: {
      /** Css custom property: --dt-colors-charts-loglevel-error-default. Default value: #cd3741. */
      Default: 'var(--dt-colors-charts-loglevel-error-default, #cd3741)',
    },
    Alert: {
      /** Css custom property: --dt-colors-charts-loglevel-alert-default. Default value: #c73d84. */
      Default: 'var(--dt-colors-charts-loglevel-alert-default, #c73d84)',
    },
    Critical: {
      /** Css custom property: --dt-colors-charts-loglevel-critical-default. Default value: #d85a9f. */
      Default: 'var(--dt-colors-charts-loglevel-critical-default, #d85a9f)',
    },
    Severe: {
      /** Css custom property: --dt-colors-charts-loglevel-severe-default. Default value: #d56b1a. */
      Default: 'var(--dt-colors-charts-loglevel-severe-default, #d56b1a)',
    },
    Warning: {
      /** Css custom property: --dt-colors-charts-loglevel-warning-default. Default value: #a9780f. */
      Default: 'var(--dt-colors-charts-loglevel-warning-default, #a9780f)',
    },
    Notice: {
      /** Css custom property: --dt-colors-charts-loglevel-notice-default. Default value: #2a7453. */
      Default: 'var(--dt-colors-charts-loglevel-notice-default, #2a7453)',
    },
    Info: {
      /** Css custom property: --dt-colors-charts-loglevel-info-default. Default value: #134fc9. */
      Default: 'var(--dt-colors-charts-loglevel-info-default, #134fc9)',
    },
    Debug: {
      /** Css custom property: --dt-colors-charts-loglevel-debug-default. Default value: #8b6ecf. */
      Default: 'var(--dt-colors-charts-loglevel-debug-default, #8b6ecf)',
    },
    None: {
      /** Css custom property: --dt-colors-charts-loglevel-none-default. Default value: #2c2f3f. */
      Default: 'var(--dt-colors-charts-loglevel-none-default, #2c2f3f)',
    },
  },
  Apdex: {
    Excellent: {
      /** Css custom property: --dt-colors-charts-apdex-excellent-default. Default value: #2a7453. */
      Default: 'var(--dt-colors-charts-apdex-excellent-default, #2a7453)',
    },
    Good: {
      /** Css custom property: --dt-colors-charts-apdex-good-default. Default value: #1c520a. */
      Default: 'var(--dt-colors-charts-apdex-good-default, #1c520a)',
    },
    Fair: {
      /** Css custom property: --dt-colors-charts-apdex-fair-default. Default value: #a9780f. */
      Default: 'var(--dt-colors-charts-apdex-fair-default, #a9780f)',
    },
    Poor: {
      /** Css custom property: --dt-colors-charts-apdex-poor-default. Default value: #d56b1a. */
      Default: 'var(--dt-colors-charts-apdex-poor-default, #d56b1a)',
    },
    Unacceptable: {
      /** Css custom property: --dt-colors-charts-apdex-unacceptable-default. Default value: #cd3741. */
      Default: 'var(--dt-colors-charts-apdex-unacceptable-default, #cd3741)',
    },
  },
  SecurityRiskLevel: {
    Muted: {
      /** Css custom property: --dt-colors-charts-security-risk-level-muted-default. Default value: #84859a. */
      Default:
        'var(--dt-colors-charts-security-risk-level-muted-default, #84859a)',
    },
    Critical: {
      /** Css custom property: --dt-colors-charts-security-risk-level-critical-default. Default value: #8a0012. */
      Default:
        'var(--dt-colors-charts-security-risk-level-critical-default, #8a0012)',
    },
    High: {
      /** Css custom property: --dt-colors-charts-security-risk-level-high-default. Default value: #cd3741. */
      Default:
        'var(--dt-colors-charts-security-risk-level-high-default, #cd3741)',
    },
    Medium: {
      /** Css custom property: --dt-colors-charts-security-risk-level-medium-default. Default value: #a9780f. */
      Default:
        'var(--dt-colors-charts-security-risk-level-medium-default, #a9780f)',
    },
    Low: {
      /** Css custom property: --dt-colors-charts-security-risk-level-low-default. Default value: #134fc9. */
      Default:
        'var(--dt-colors-charts-security-risk-level-low-default, #134fc9)',
    },
    None: {
      /** Css custom property: --dt-colors-charts-security-risk-level-none-default. Default value: #2c2f3f. */
      Default:
        'var(--dt-colors-charts-security-risk-level-none-default, #2c2f3f)',
    },
  },
  VulnerabilityStatus: {
    Muted: {
      /** Css custom property: --dt-colors-charts-vulnerability-status-muted-default. Default value: #84859a. */
      Default:
        'var(--dt-colors-charts-vulnerability-status-muted-default, #84859a)',
    },
    Resolved: {
      /** Css custom property: --dt-colors-charts-vulnerability-status-resolved-default. Default value: #3e8e6a. */
      Default:
        'var(--dt-colors-charts-vulnerability-status-resolved-default, #3e8e6a)',
    },
    Affected: {
      /** Css custom property: --dt-colors-charts-vulnerability-status-affected-default. Default value: #cd3741. */
      Default:
        'var(--dt-colors-charts-vulnerability-status-affected-default, #cd3741)',
    },
  },
  Threshold: {
    Good: {
      /** Css custom property: --dt-colors-charts-threshold-good-default. Default value: #2a7453. */
      Default: 'var(--dt-colors-charts-threshold-good-default, #2a7453)',
    },
    Warning: {
      /** Css custom property: --dt-colors-charts-threshold-warning-default. Default value: #a9780f. */
      Default: 'var(--dt-colors-charts-threshold-warning-default, #a9780f)',
    },
    Bad: {
      /** Css custom property: --dt-colors-charts-threshold-bad-default. Default value: #cd3741. */
      Default: 'var(--dt-colors-charts-threshold-bad-default, #cd3741)',
    },
  },
  Rainbow: {
    Red: {
      /** Css custom property: --dt-colors-charts-rainbow-red-default. Default value: #cd3741. */
      Default: 'var(--dt-colors-charts-rainbow-red-default, #cd3741)',
    },
    Orange: {
      /** Css custom property: --dt-colors-charts-rainbow-orange-default. Default value: #d56b1a. */
      Default: 'var(--dt-colors-charts-rainbow-orange-default, #d56b1a)',
    },
    Yellow: {
      /** Css custom property: --dt-colors-charts-rainbow-yellow-default. Default value: #a9780f. */
      Default: 'var(--dt-colors-charts-rainbow-yellow-default, #a9780f)',
    },
    Moss: {
      /** Css custom property: --dt-colors-charts-rainbow-moss-default. Default value: #2a7453. */
      Default: 'var(--dt-colors-charts-rainbow-moss-default, #2a7453)',
    },
    Blue: {
      /** Css custom property: --dt-colors-charts-rainbow-blue-default. Default value: #134fc9. */
      Default: 'var(--dt-colors-charts-rainbow-blue-default, #134fc9)',
    },
    Magenta: {
      /** Css custom property: --dt-colors-charts-rainbow-magenta-default. Default value: #9033a3. */
      Default: 'var(--dt-colors-charts-rainbow-magenta-default, #9033a3)',
    },
  },
  Sequential: {
    PinkPurple: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-01-default. Default value: #d85a9f. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-01-default, #d85a9f)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-02-default. Default value: #c6539f. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-02-default, #c6539f)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-03-default. Default value: #b450a3. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-03-default, #b450a3)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-04-default. Default value: #9f49a2. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-04-default, #9f49a2)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-05-default. Default value: #8d45a5. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-05-default, #8d45a5)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-06-default. Default value: #7640a5. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-06-default, #7640a5)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-07-default. Default value: #5d3ba5. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-07-default, #5d3ba5)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-08-default. Default value: #4038a8. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-08-default, #4038a8)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-pink-purple-color-09-default. Default value: #0035a8. */
        Default:
          'var(--dt-colors-charts-sequential-pink-purple-color-09-default, #0035a8)',
      },
    },
    BlueTurquoise: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-01-default. Default value: #0035a8. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-01-default, #0035a8)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-02-default. Default value: #1d41a5. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-02-default, #1d41a5)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-03-default. Default value: #284e9f. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-03-default, #284e9f)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-04-default. Default value: #2f5998. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-04-default, #2f5998)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-05-default. Default value: #336794. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-05-default, #336794)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-06-default. Default value: #31708c. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-06-default, #31708c)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-07-default. Default value: #307c88. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-07-default, #307c88)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-08-default. Default value: #2a8981. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-08-default, #2a8981)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-blue-turquoise-color-09-default. Default value: #1d957b. */
        Default:
          'var(--dt-colors-charts-sequential-blue-turquoise-color-09-default, #1d957b)',
      },
    },
    Blue: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-01-default. Default value: #001b85. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-01-default, #001b85)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-02-default. Default value: #0035a8. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-02-default, #0035a8)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-03-default. Default value: #134fc9. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-03-default, #134fc9)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-04-default. Default value: #3f63e4. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-04-default, #3f63e4)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-05-default. Default value: #627cfe. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-05-default, #627cfe)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-06-default. Default value: #8a9bff. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-06-default, #8a9bff)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-07-default. Default value: #a8b7ff. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-07-default, #a8b7ff)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-08-default. Default value: #bdc8ff. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-08-default, #bdc8ff)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-blue-color-09-default. Default value: #d6deff. */
        Default:
          'var(--dt-colors-charts-sequential-blue-color-09-default, #d6deff)',
      },
    },
    Grey: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-01-default. Default value: #111422. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-01-default, #111422)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-02-default. Default value: #2c2f3f. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-02-default, #2c2f3f)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-03-default. Default value: #484a5b. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-03-default, #484a5b)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-04-default. Default value: #66687a. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-04-default, #66687a)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-05-default. Default value: #84859a. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-05-default, #84859a)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-06-default. Default value: #a7a9be. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-06-default, #a7a9be)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-07-default. Default value: #cacce2. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-07-default, #cacce2)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-08-default. Default value: #d8d9e9. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-08-default, #d8d9e9)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-grey-color-09-default. Default value: #e1e3ef. */
        Default:
          'var(--dt-colors-charts-sequential-grey-color-09-default, #e1e3ef)',
      },
    },
    Moss: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-01-default. Default value: #084427. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-01-default, #084427)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-02-default. Default value: #195c3d. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-02-default, #195c3d)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-03-default. Default value: #2a7453. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-03-default, #2a7453)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-04-default. Default value: #3e8e6a. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-04-default, #3e8e6a)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-05-default. Default value: #509575. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-05-default, #509575)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-06-default. Default value: #75c29d. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-06-default, #75c29d)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-07-default. Default value: #93dcb8. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-07-default, #93dcb8)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-08-default. Default value: #b4e4cd. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-08-default, #b4e4cd)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-moss-color-09-default. Default value: #d4ece0. */
        Default:
          'var(--dt-colors-charts-sequential-moss-color-09-default, #d4ece0)',
      },
    },
    Turquoise: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-01-default. Default value: #004733. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-01-default, #004733)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-02-default. Default value: #00523d. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-02-default, #00523d)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-03-default. Default value: #006650. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-03-default, #006650)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-04-default. Default value: #047c64. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-04-default, #047c64)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-05-default. Default value: #1d957b. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-05-default, #1d957b)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-06-default. Default value: #38ad92. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-06-default, #38ad92)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-07-default. Default value: #52c7aa. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-07-default, #52c7aa)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-08-default. Default value: #78dec1. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-08-default, #78dec1)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-turquoise-color-09-default. Default value: #c0ece0. */
        Default:
          'var(--dt-colors-charts-sequential-turquoise-color-09-default, #c0ece0)',
      },
    },
    Pink: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-01-default. Default value: #6b1441. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-01-default, #6b1441)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-02-default. Default value: #872256. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-02-default, #872256)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-03-default. Default value: #a83470. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-03-default, #a83470)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-04-default. Default value: #c73d84. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-04-default, #c73d84)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-05-default. Default value: #d85a9f. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-05-default, #d85a9f)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-06-default. Default value: #e675b5. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-06-default, #e675b5)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-07-default. Default value: #f291cb. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-07-default, #f291cb)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-08-default. Default value: #fcb5e2. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-08-default, #fcb5e2)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-pink-color-09-default. Default value: #fed7f0. */
        Default:
          'var(--dt-colors-charts-sequential-pink-color-09-default, #fed7f0)',
      },
    },
    Yellow: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-01-default. Default value: #573b00. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-01-default, #573b00)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-02-default. Default value: #614200. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-02-default, #614200)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-03-default. Default value: #755000. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-03-default, #755000)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-04-default. Default value: #8f6200. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-04-default, #8f6200)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-05-default. Default value: #a9780f. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-05-default, #a9780f)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-06-default. Default value: #c79323. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-06-default, #c79323)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-07-default. Default value: #dfb14e. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-07-default, #dfb14e)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-08-default. Default value: #f1cd7e. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-08-default, #f1cd7e)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-yellow-color-09-default. Default value: #f8e1af. */
        Default:
          'var(--dt-colors-charts-sequential-yellow-color-09-default, #f8e1af)',
      },
    },
    Petrol: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-01-default. Default value: #00304d. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-01-default, #00304d)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-02-default. Default value: #114964. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-02-default, #114964)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-03-default. Default value: #21607d. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-03-default, #21607d)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-04-default. Default value: #307697. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-04-default, #307697)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-05-default. Default value: #438fb1. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-05-default, #438fb1)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-06-default. Default value: #5ba7cd. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-06-default, #5ba7cd)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-07-default. Default value: #81c8ef. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-07-default, #81c8ef)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-08-default. Default value: #aaddf9. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-08-default, #aaddf9)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-petrol-color-09-default. Default value: #cbe7f6. */
        Default:
          'var(--dt-colors-charts-sequential-petrol-color-09-default, #cbe7f6)',
      },
    },
    Purple: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-01-default. Default value: #32246a. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-01-default, #32246a)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-02-default. Default value: #453380. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-02-default, #453380)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-03-default. Default value: #5e489d. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-03-default, #5e489d)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-04-default. Default value: #755abf. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-04-default, #755abf)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-05-default. Default value: #8b6ecf. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-05-default, #8b6ecf)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-06-default. Default value: #a184dc. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-06-default, #a184dc)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-07-default. Default value: #bb9eeb. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-07-default, #bb9eeb)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-08-default. Default value: #d5b9f8. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-08-default, #d5b9f8)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-purple-color-09-default. Default value: #e9d7fe. */
        Default:
          'var(--dt-colors-charts-sequential-purple-color-09-default, #e9d7fe)',
      },
    },
    Pear: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-01-default. Default value: #084200. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-01-default, #084200)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-02-default. Default value: #1c520a. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-02-default, #1c520a)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-03-default. Default value: #306615. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-03-default, #306615)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-04-default. Default value: #457a1f. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-04-default, #457a1f)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-05-default. Default value: #649438. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-05-default, #649438)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-06-default. Default value: #83b455. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-06-default, #83b455)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-07-default. Default value: #9fcb76. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-07-default, #9fcb76)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-08-default. Default value: #b5de8c. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-08-default, #b5de8c)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-pear-color-09-default. Default value: #d3e9be. */
        Default:
          'var(--dt-colors-charts-sequential-pear-color-09-default, #d3e9be)',
      },
    },
    Brown: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-01-default. Default value: #5c1d00. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-01-default, #5c1d00)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-02-default. Default value: #6f2e11. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-02-default, #6f2e11)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-03-default. Default value: #8f4624. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-03-default, #8f4624)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-04-default. Default value: #a95d37. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-04-default, #a95d37)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-05-default. Default value: #bc724e. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-05-default, #bc724e)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-06-default. Default value: #c98769. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-06-default, #c98769)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-07-default. Default value: #dfa486. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-07-default, #dfa486)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-08-default. Default value: #f2bfa6. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-08-default, #f2bfa6)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-brown-color-09-default. Default value: #fddece. */
        Default:
          'var(--dt-colors-charts-sequential-brown-color-09-default, #fddece)',
      },
    },
    Red: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-01-default. Default value: #610000. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-01-default, #610000)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-02-default. Default value: #8a0012. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-02-default, #8a0012)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-03-default. Default value: #ae132d. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-03-default, #ae132d)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-04-default. Default value: #cd3741. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-04-default, #cd3741)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-05-default. Default value: #eb565b. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-05-default, #eb565b)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-06-default. Default value: #ff7a7a. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-06-default, #ff7a7a)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-07-default. Default value: #ffa6a3. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-07-default, #ffa6a3)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-08-default. Default value: #ffb8b3. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-08-default, #ffb8b3)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-red-color-09-default. Default value: #ffd9d6. */
        Default:
          'var(--dt-colors-charts-sequential-red-color-09-default, #ffd9d6)',
      },
    },
    Magenta: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-01-default. Default value: #59006b. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-01-default, #59006b)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-02-default. Default value: #761b88. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-02-default, #761b88)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-03-default. Default value: #9033a3. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-03-default, #9033a3)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-04-default. Default value: #af4bbe. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-04-default, #af4bbe)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-05-default. Default value: #ba6bc2. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-05-default, #ba6bc2)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-06-default. Default value: #e183e7. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-06-default, #e183e7)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-07-default. Default value: #fca0fd. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-07-default, #fca0fd)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-08-default. Default value: #fdb4fd. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-08-default, #fdb4fd)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-magenta-color-09-default. Default value: #faccfa. */
        Default:
          'var(--dt-colors-charts-sequential-magenta-color-09-default, #faccfa)',
      },
    },
    Orange: {
      Color01: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-01-default. Default value: #662c00. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-01-default, #662c00)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-02-default. Default value: #87420d. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-02-default, #87420d)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-03-default. Default value: #ab5412. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-03-default, #ab5412)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-04-default. Default value: #c36218. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-04-default, #c36218)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-05-default. Default value: #d56b1a. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-05-default, #d56b1a)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-06-default. Default value: #e57e2e. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-06-default, #e57e2e)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-07-default. Default value: #eb9a5c. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-07-default, #eb9a5c)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-08-default. Default value: #efb080. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-08-default, #efb080)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-sequential-orange-color-09-default. Default value: #f4caa9. */
        Default:
          'var(--dt-colors-charts-sequential-orange-color-09-default, #f4caa9)',
      },
    },
  },
  Diverging: {
    OrangeBlue: {
      Color01: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-01-default. Default value: #662c00. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-01-default, #662c00)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-02-default. Default value: #ab5412. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-02-default, #ab5412)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-03-default. Default value: #d56b1a. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-03-default, #d56b1a)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-04-default. Default value: #eb9a5c. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-04-default, #eb9a5c)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-05-default. Default value: #f4caa9. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-05-default, #f4caa9)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-06-default. Default value: #f5eee0. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-06-default, #f5eee0)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-07-default. Default value: #d6deff. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-07-default, #d6deff)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-08-default. Default value: #a8b7ff. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-08-default, #a8b7ff)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-09-default. Default value: #627cfe. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-09-default, #627cfe)',
      },
      Color10: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-10-default. Default value: #134fc9. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-10-default, #134fc9)',
      },
      Color11: {
        /** Css custom property: --dt-colors-charts-diverging-orange-blue-color-11-default. Default value: #001b85. */
        Default:
          'var(--dt-colors-charts-diverging-orange-blue-color-11-default, #001b85)',
      },
    },
    RedBlue: {
      Color01: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-01-default. Default value: #610000. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-01-default, #610000)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-02-default. Default value: #ae132d. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-02-default, #ae132d)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-03-default. Default value: #eb565b. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-03-default, #eb565b)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-04-default. Default value: #ffa6a3. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-04-default, #ffa6a3)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-05-default. Default value: #ffd9d6. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-05-default, #ffd9d6)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-06-default. Default value: #f5eee0. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-06-default, #f5eee0)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-07-default. Default value: #d6deff. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-07-default, #d6deff)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-08-default. Default value: #a8b7ff. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-08-default, #a8b7ff)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-09-default. Default value: #627cfe. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-09-default, #627cfe)',
      },
      Color10: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-10-default. Default value: #134fc9. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-10-default, #134fc9)',
      },
      Color11: {
        /** Css custom property: --dt-colors-charts-diverging-red-blue-color-11-default. Default value: #001b85. */
        Default:
          'var(--dt-colors-charts-diverging-red-blue-color-11-default, #001b85)',
      },
    },
    RedPurple: {
      Color01: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-01-default. Default value: #610000. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-01-default, #610000)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-02-default. Default value: #ae132d. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-02-default, #ae132d)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-03-default. Default value: #eb565b. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-03-default, #eb565b)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-04-default. Default value: #ffa6a3. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-04-default, #ffa6a3)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-05-default. Default value: #ffd9d6. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-05-default, #ffd9d6)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-06-default. Default value: #f5eee0. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-06-default, #f5eee0)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-07-default. Default value: #e9d7fe. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-07-default, #e9d7fe)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-08-default. Default value: #bb9eeb. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-08-default, #bb9eeb)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-09-default. Default value: #8b6ecf. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-09-default, #8b6ecf)',
      },
      Color10: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-10-default. Default value: #5e489d. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-10-default, #5e489d)',
      },
      Color11: {
        /** Css custom property: --dt-colors-charts-diverging-red-purple-color-11-default. Default value: #32246a. */
        Default:
          'var(--dt-colors-charts-diverging-red-purple-color-11-default, #32246a)',
      },
    },
    BlueMoss: {
      Color01: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-01-default. Default value: #001b85. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-01-default, #001b85)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-02-default. Default value: #134fc9. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-02-default, #134fc9)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-03-default. Default value: #627cfe. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-03-default, #627cfe)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-04-default. Default value: #a8b7ff. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-04-default, #a8b7ff)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-05-default. Default value: #d6deff. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-05-default, #d6deff)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-06-default. Default value: #f5eee0. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-06-default, #f5eee0)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-07-default. Default value: #d4ece0. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-07-default, #d4ece0)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-08-default. Default value: #93dcb8. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-08-default, #93dcb8)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-09-default. Default value: #509575. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-09-default, #509575)',
      },
      Color10: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-10-default. Default value: #2a7453. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-10-default, #2a7453)',
      },
      Color11: {
        /** Css custom property: --dt-colors-charts-diverging-blue-moss-color-11-default. Default value: #084427. */
        Default:
          'var(--dt-colors-charts-diverging-blue-moss-color-11-default, #084427)',
      },
    },
    PurpleYellow: {
      Color01: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-01-default. Default value: #32246a. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-01-default, #32246a)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-02-default. Default value: #5e489d. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-02-default, #5e489d)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-03-default. Default value: #8b6ecf. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-03-default, #8b6ecf)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-04-default. Default value: #bb9eeb. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-04-default, #bb9eeb)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-05-default. Default value: #e9d7fe. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-05-default, #e9d7fe)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-06-default. Default value: #f5eee0. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-06-default, #f5eee0)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-07-default. Default value: #f8e1af. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-07-default, #f8e1af)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-08-default. Default value: #dfb14e. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-08-default, #dfb14e)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-09-default. Default value: #a9780f. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-09-default, #a9780f)',
      },
      Color10: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-10-default. Default value: #755000. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-10-default, #755000)',
      },
      Color11: {
        /** Css custom property: --dt-colors-charts-diverging-purple-yellow-color-11-default. Default value: #573b00. */
        Default:
          'var(--dt-colors-charts-diverging-purple-yellow-color-11-default, #573b00)',
      },
    },
    RedGreen: {
      Color01: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-01-default. Default value: #610000. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-01-default, #610000)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-02-default. Default value: #ae132d. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-02-default, #ae132d)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-03-default. Default value: #eb565b. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-03-default, #eb565b)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-04-default. Default value: #ffa6a3. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-04-default, #ffa6a3)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-05-default. Default value: #ffd9d6. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-05-default, #ffd9d6)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-06-default. Default value: #f5eee0. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-06-default, #f5eee0)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-07-default. Default value: #d4ece0. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-07-default, #d4ece0)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-08-default. Default value: #93dcb8. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-08-default, #93dcb8)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-09-default. Default value: #509575. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-09-default, #509575)',
      },
      Color10: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-10-default. Default value: #2a7453. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-10-default, #2a7453)',
      },
      Color11: {
        /** Css custom property: --dt-colors-charts-diverging-red-green-color-11-default. Default value: #084427. */
        Default:
          'var(--dt-colors-charts-diverging-red-green-color-11-default, #084427)',
      },
    },
    OrangePetrol: {
      Color01: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-01-default. Default value: #662c00. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-01-default, #662c00)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-02-default. Default value: #ab5412. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-02-default, #ab5412)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-03-default. Default value: #d56b1a. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-03-default, #d56b1a)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-04-default. Default value: #eb9a5c. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-04-default, #eb9a5c)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-05-default. Default value: #f4caa9. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-05-default, #f4caa9)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-06-default. Default value: #f5eee0. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-06-default, #f5eee0)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-07-default. Default value: #cbe7f6. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-07-default, #cbe7f6)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-08-default. Default value: #81c8ef. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-08-default, #81c8ef)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-09-default. Default value: #438fb1. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-09-default, #438fb1)',
      },
      Color10: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-10-default. Default value: #21607d. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-10-default, #21607d)',
      },
      Color11: {
        /** Css custom property: --dt-colors-charts-diverging-orange-petrol-color-11-default. Default value: #00304d. */
        Default:
          'var(--dt-colors-charts-diverging-orange-petrol-color-11-default, #00304d)',
      },
    },
    PinkGreen: {
      Color01: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-01-default. Default value: #6b1441. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-01-default, #6b1441)',
      },
      Color02: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-02-default. Default value: #a83470. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-02-default, #a83470)',
      },
      Color03: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-03-default. Default value: #d85a9f. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-03-default, #d85a9f)',
      },
      Color04: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-04-default. Default value: #f291cb. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-04-default, #f291cb)',
      },
      Color05: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-05-default. Default value: #fed7f0. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-05-default, #fed7f0)',
      },
      Color06: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-06-default. Default value: #f5eee0. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-06-default, #f5eee0)',
      },
      Color07: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-07-default. Default value: #d4ece0. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-07-default, #d4ece0)',
      },
      Color08: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-08-default. Default value: #93dcb8. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-08-default, #93dcb8)',
      },
      Color09: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-09-default. Default value: #509575. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-09-default, #509575)',
      },
      Color10: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-10-default. Default value: #2a7453. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-10-default, #2a7453)',
      },
      Color11: {
        /** Css custom property: --dt-colors-charts-diverging-pink-green-color-11-default. Default value: #084427. */
        Default:
          'var(--dt-colors-charts-diverging-pink-green-color-11-default, #084427)',
      },
    },
  },
};
export default {
  Theme,
  Background,
  Border,
  Text,
  Icon,
  Syntax,
  Charts,
};
